import React from 'react'
import { Link } from 'react-router-dom'
import TestimonialSlider from './TestimonialSlider'

function About() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">About Us</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- About Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col-lg-6">
                    <div className="about_image mb-xl-30">
                        <img src="/tm/react/fit2fine/assets/images/about.jpg" alt="img" className="image-fit"/>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="section-header text-start">
                        <h3 className="title">Who We <span> Are</span></h3>
                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                    </div>
                    <Link to="/about" className="thm-btn mb-xl-30">Read More</Link>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- About End -->
    <!-- Testimonials Start --> */}
    <TestimonialSlider/>
    {/* <!-- Testimonials End -->
    <!-- Pricing Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="section-header">
                <h3 className="title">Followship <span> Cards</span></h3>
                <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore </p>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">40</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">3 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
              
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">60</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">5 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
                
                <div className="col-lg-4 col-md-6">
                    <div className="pricing_box mask-image contain" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_4.png)' }}>
                        <div className="main_price">
                            <h3 className="price mb-0">99</h3>
                            <div className="sub_text">
                                <p className="mb-0">99</p>
                                <p className="mb-0">7 Months</p>
                            </div>
                        </div>
                        <ul className="includes">
                            <li>Unlimited Club Access</li>
                            <li>Group Attendance</li>
                            <li>Gym Visits</li>
                            <li>Visits To The Bath Complex</li>
                            <li>Gym, Flight, Club</li>
                        </ul>
                        <Link to="/pricing" className="thm-btn btn-small">Buy Now</Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default About